// Best-effort source-layer classification for the vector tilesets used by the
// configured map styles. Each tileset has its own source-layer schema, so these
// lists must be updated when adding styles backed by a new schema.

/**
 * Whether features from this source layer carry semantic labels or POIs and
 * should be selectable without requiring extra properties such as a name.
 */
export function isSemanticSourceLayer(sourceLayer: string): boolean {
  return SEMANTIC_SOURCE_LAYERS.has(sourceLayer);
}

/**
 * Whether this source layer represents point-like POIs rather than broader
 * labels or area geometry.
 */
export function isPoiSourceLayer(sourceLayer: string): boolean {
  return POI_SOURCE_LAYERS.has(sourceLayer);
}

const SEMANTIC_SOURCE_LAYERS = new Set([
  // Shared/OpenMapTiles schemas
  "aerodrome_label",
  "mountain_peak",
  "park",
  "place",
  "poi",
  "transportation_name",
  "water_name",

  // Jawg
  "natural_label",
  "poi_label",
  "transit_label",

  // MapTiler v4
  "archipelago_label",
  "city_label",
  "country_disputed_label",
  "country_label",
  "island_label",
  "outdoor_poi",
  "pathway_label",
  "place_label",
  "poi_accommodation",
  "poi_culture",
  "poi_education",
  "poi_food",
  "poi_healthcare",
  "poi_public",
  "poi_shopping",
  "poi_sport",
  "poi_station",
  "poi_tourism",
  "poi_transport",
  "protected_area_major_label",
  "protected_area_minor_label",
  "railway_label",
  "ridge_label",
  "road_label",
  "state_label",
  "town_label",
  "water_centroid",
  "water_label",

  // Thunderforest
  "bus-stop",
  "bus-stop-label",
  "country-label",
  "path-label",
  "place-label",
  "railway-platform-label",
  "railway-station",
  "road-label",
  "state-label",
  "stop-zone-label",
]);

const POI_SOURCE_LAYERS = new Set([
  // Shared/OpenMapTiles schemas
  "poi",

  // Jawg
  "poi_label",
  "transit_label",

  // MapTiler v4
  "outdoor_poi",
  "poi_accommodation",
  "poi_culture",
  "poi_education",
  "poi_food",
  "poi_healthcare",
  "poi_public",
  "poi_shopping",
  "poi_sport",
  "poi_station",
  "poi_tourism",
  "poi_transport",

  // Thunderforest
  "bus-stop",
  "bus-stop-label",
  "railway-platform-label",
  "railway-station",
  "stop-zone-label",
]);
